import { observable, action, makeObservable } from 'mobx';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';
import { Common } from 'src/domains/common/Common';

export class LazyImageLoadState {
    public static get = AutoWeakMap.create(
        (_common: Common, src: string): LazyImageLoadState => new LazyImageLoadState(src)
    );

    private static cache = new Set<string>();

    @observable public allowShow: boolean = false;
    public readonly src: string;

    public constructor(src: string) {
        makeObservable(this);
        this.src = src;

        if (typeof window !== 'undefined' && LazyImageLoadState.cache.has(src)) {
            this.allowShow = true;
        }
    }

    @action public onLoad = (): void => {
        this.allowShow = true;
        LazyImageLoadState.cache.add(this.src);
    };
}
